import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProcessoService } from '@app/services/processo.service';
import { ProcessoAnexo } from '@app/models/processo-anexo.model';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { UtilitarioService } from '../../../../services/utilitario.service';
import { UsuarioTipoService } from '@app/services/usuario-tipo.service';

@Component({
  selector: 'app-anexos',
  templateUrl: './anexos.component.html',
  styleUrls: ['./anexos.component.scss']
})
export class AnexosComponent implements OnInit {


  lstProcessoAnexo: Array<ProcessoAnexo> = [];
  processoId: number;
  bsModalRef: BsModalRef;
  desativaAposSolicitarArquivo: boolean = false;

  processoArquivado: boolean = false;

  acessoGerenciarSigilo: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private processoService: ProcessoService,
    private modalService: BsModalService,
    @Inject(ToastrService) public toastr: ToastrService,
    private utilitarioService: UtilitarioService,
    private usuarioTipoService: UsuarioTipoService
  ) { }

  ngOnInit() {
    this.usuarioTipoService.verificaPermissaoUsuario().subscribe((permissoes: any) => {
      this.acessoGerenciarSigilo = permissoes.find(x => x.Descricao == 'GerenciarSigilo').Selecionado;
    });

    this.router.events.subscribe(() => window.scrollTo(0, 0));

    this.route.parent.params.subscribe(
      (params: any) => {
        this.processoId = params['id'];
        this.processoService.obterAnexos(this.processoId).toPromise().then((data) => this.lstProcessoAnexo = data);
      });
  }

  retornaTipoMov(tipoMov: number): string {
    switch (tipoMov) {
      case 1: return 'Administrativa';
      case 2: return 'Execução Provisória';
      case 3: return 'Judicial';
      default: return '';
    }
  }

  obterArquivo(anexo: ProcessoAnexo): void {
    this.desativaAposSolicitarArquivo = true;
    if(anexo.Sigiloso && !anexo.PermissaoAcessarSigilo && !this.acessoGerenciarSigilo){
      this.toastr.error('Anexo sigiloso, solicite acesso ao seu gestor!');
      return;
    }

    this.processoService.obterSasUrlParaDownloadMovimentacaoAnexo(anexo.Id).subscribe({
      next: (uriString) => {
        const link = document.createElement('a');
        link.href = uriString;
        
        link.target = '_blank';
        link.rel = 'noopener noreferrer'; 
        
        link.download = ''; 
    
        document.body.appendChild(link);
        link.click();
        link.remove();
      },
      error: (error) => {
        const mensagemErro = error?.error?.errors?.[0] || 'Ocorreu um erro ao solicitar o arquivo.';
        this.toastr.error(mensagemErro);
        this.desativaAposSolicitarArquivo = false;
      },
      complete: () => {
        this.desativaAposSolicitarArquivo = false;
      }
    });
  }

  deletarArquivo(id: number): void {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja realmente deletar o anexo: ' + id;
    this.bsModalRef.content.confirmar = () => {
      this.processoService.deletarAnexo(id).toPromise()
      .then(() => {
        this.processoService.obterAnexos(this.processoId)
        .toPromise()
        .then((listaAnexos) => this.lstProcessoAnexo = listaAnexos)
      }).catch (e=> this.toastr.error(e.error.errors [0]));
    };
  }

}

